import React from "react";
import ApiHelper from "../../../../../../Helpers/ApiHelper";
import { folderEnum } from "../../../../../../Helpers/EnumHelper";

export default function ImageSpace({ item }) {
  return (
    <div className="_flex-center">
      <img style={{ maxWidth: "100%" }} src={ApiHelper.cloudFrontURL + folderEnum.scheme + item.imageName} />
    </div>
  );
}
